import * as Popover from "@radix-ui/react-popover";
import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import { SVGIcon } from "../../../common/SVGIcon";
import { getIcon } from "../OrderDetailsTrackerModal";
import { EventState, UnifiedDeliveryEvent } from "../types";

import modalStyles from "../OrderDetailsTrackerModal/index.module.scss";
import styles from "./index.module.scss";

interface IProps {
    unifiedEvents: UnifiedDeliveryEvent[];
}

export const TrackShipmentDetailsSimpleTimeline = (
    props: IProps,
): React.JSX.Element => {
    if (!props.unifiedEvents) {
        return <></>;
    }

    const currentEvent =
        props.unifiedEvents.find(
            (event) => event.event_state === EventState.CURRENT,
        ) || null;

    return (
        <div>
            {currentEvent && (
                <div className={styles.titleWrapper}>
                    <h3 className={styles.title}>
                        {currentEvent.tracking_step_title}
                    </h3>
                    <Popover.Root>
                        <Popover.Trigger asChild>
                            <button className={styles.tooltipButton}>
                                <SVGIcon
                                    name="tooltipIcon"
                                    alt={t`View More Details`}
                                    aria-hidden="true"
                                />
                            </button>
                        </Popover.Trigger>
                        <Popover.Portal>
                            <Popover.Content
                                side="left"
                                className={classNames([
                                    modalStyles.orderDetailsTrackerModalContent,
                                    styles.modalContent,
                                ])}
                            >
                                <Popover.Close asChild>
                                    <button className={styles.closeButton}>
                                        <SVGIcon
                                            name="closeIcon"
                                            alt={t`Close`}
                                            aria-hidden="true"
                                        />
                                    </button>
                                </Popover.Close>
                                <Popover.Arrow asChild>
                                    <div className={styles.modalArrow} />
                                </Popover.Arrow>
                                <div>
                                    <h1 className={styles.modalTitle}>
                                        {props.unifiedEvents.length > 5
                                            ? t`White Glove Delivery`
                                            : t`UPS Delivery`}
                                    </h1>
                                    <h2 className={styles.modalSubTitle}>
                                        {t`Follow The Process of Your Order`}
                                    </h2>
                                    <ul className={styles.modalTimeline}>
                                        {props.unifiedEvents.map(
                                            (event, index) => {
                                                const icon = event.icon_code
                                                    ? getIcon(event.icon_code)
                                                    : null;

                                                const iconClasses = classNames({
                                                    [styles.stepIconComplete]:
                                                        event.event_state ===
                                                        EventState.COMPLETE,
                                                    [styles.stepIconCurrent]:
                                                        event.event_state ===
                                                        EventState.CURRENT,
                                                    [styles.stepIcon]:
                                                        event.event_state ===
                                                        EventState.INCOMPLETE,
                                                });
                                                return (
                                                    <li
                                                        key={`deliveryStep-${index}`}
                                                        className={
                                                            event.event_state ===
                                                            EventState.INCOMPLETE
                                                                ? styles.incompleteStep
                                                                : styles.step
                                                        }
                                                    >
                                                        {icon && (
                                                            <SVG
                                                                className={
                                                                    iconClasses
                                                                }
                                                                aria-hidden="true"
                                                                src={icon}
                                                            />
                                                        )}
                                                        <div
                                                            className={
                                                                styles.modalStep
                                                            }
                                                        >
                                                            <h3>
                                                                {
                                                                    event.tracking_step_title
                                                                }
                                                            </h3>
                                                            <p>
                                                                {event.tracking_step_copy_condensed
                                                                    ? event.tracking_step_copy_condensed
                                                                    : event.tracking_step_copy}
                                                            </p>
                                                        </div>
                                                    </li>
                                                );
                                            },
                                        )}
                                    </ul>
                                </div>
                            </Popover.Content>
                        </Popover.Portal>
                    </Popover.Root>
                </div>
            )}
            <ul className={styles.timeline}>
                {props.unifiedEvents.map((event, index) => {
                    const icon = event.icon_code
                        ? getIcon(event.icon_code)
                        : null;

                    const iconClasses = classNames({
                        [styles.stepIconComplete]:
                            event.event_state === EventState.COMPLETE,
                        [styles.stepIconCurrent]:
                            event.event_state === EventState.CURRENT,
                        [styles.stepIcon]:
                            event.event_state === EventState.INCOMPLETE,
                    });
                    return (
                        <li key={`deliveryStep-${index}`}>
                            {icon && (
                                <SVG
                                    className={iconClasses}
                                    aria-hidden="true"
                                    src={icon}
                                />
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
